"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'tools.dynamicListings.name': 'Dynamic Listings',
    'tools.dynamicListings.description': 'Display a contextual listings panel when a specific conversation condition is met',
};
